import React from 'react';
import FormGroupPlainText from "./formGroupPlainText";
import '../style/generalTab.css'
import Dots from 'react-activity/lib/Dots';
import '../style/dots.css';
import CenteredDots from "./General/centeredDots";
import FormResponseMessage from "./formResponseMessage";

const DocumentsTab = (props) => {
    if(props.fetchingAllApplicationAttachments){
        return (
            <CenteredDots/>
        )
    }
    if(props.failedToGetApplicationAttachments){
        return (
            <FormResponseMessage
                CenterWrapper="col-sm-12 mt-15"
                MessageStyle="formResponseMessage-reject"
                Message={props.failedToGetApplicationAttachments}
            />
        )
    }
    return (
        <div className="col-sm-12 generalTab-wrapper">
            <form className="form-horizontal" >
                {
                    props.RowData.map((data, index) => {
                        return <div key={index}>
                            <FormGroupPlainText
                                Label={data.key}
                                InputWrapper="manageSolicitorAccount-data col-xs-9"
                                Text={data.value}
                            />
                            <div className="row" >
                                <div className="col-sm-12">
                                    <hr className="generalTab-hr"/>
                                </div>
                            </div>
                        </div>
                    })
                }
            </form>
            {
                props.failedToGetDocumentMsg && (
                    <div className={'row'}>
                        <FormResponseMessage
                            CenterWrapper="col-sm-12"
                            MessageStyle="formResponseMessage-reject"
                            Message={props.failedToGetDocumentMsg}
                        />
                    </div>
                )
            }
            {
                props.failedDeleteMsg && (
                    <div className={'row'}>
                        <FormResponseMessage
                            CenterWrapper="col-sm-12"
                            MessageStyle="formResponseMessage-reject"
                            Message={props.failedDeleteMsg}
                        />
                    </div>
                )
            }
            {
                (props.fetchingDocument || props.deletingDocument) && (
                    <CenteredDots/>
                )
            }
        </div>
    )
};

export default DocumentsTab;